/**
 * @module M/control/CompleteTOCControl
 */

/*
eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["item"] }]
*/

import CompleteTOCImplControl from 'impl/completetoccontrol';
import template from '../../templates/completetoc';
import metadataTemplate from '../../templates/metadata';

/*
const listenAll = (html, selector, type, callback) => {
  const nodeList = html.querySelectorAll(selector);
  Array.prototype.forEach.call(nodeList, node => node.addEventListener(type, evt => callback(evt)));
};
*/

export default class CompleteTOCControl extends M.Control {
  /**
   * @constructor
   * @extends {M.Control}
   * @api
   */
  constructor() {
    if (M.utils.isUndefined(CompleteTOCImplControl)) {
      M.exception('La implementación usada no puede crear controles CompleteTOCControl');
    }

    const impl = new CompleteTOCImplControl();
    super(impl, 'CompleteTOC');

    // facade control goes to impl as reference param
    impl.facadeControl = this;

    /**
     * Map
     * @private
     * @type {Object}
     */
    this.map_ = undefined;

    /**
     * Template
     * @private
     * @type {String}
     */
    this.template_ = undefined;
  }

  /**
   * This function creates the view
   *
   * @public
   * @function
   * @param {M.Map} map to add the control
   * @api
   */
  createView(map) {
    this.map_ = map;
    return new Promise((success, fail) => {
      this.getTemplateVariables(map).then((templateVars) => {
        const html = M.template.compileSync(template, {
          vars: templateVars,
        });

        this.template_ = html;
        success(html);
        this.template_.addEventListener('click', this.clickLayer.bind(this), false);
        this.template_.addEventListener('input', this.inputLayer.bind(this), false);
        this.getImpl().registerEvents();
        this.render();
      });
    });
  }

  /**
   * Sets the visibility of the clicked layer
   *
   * @public
   * @function
   * @api stable
   */
  inputLayer(evtParameter) {
    const evt = (evtParameter || window.event);
    const groupId = evt.target.getAttribute('data-group-id');
    let group = null;
    if (!M.utils.isNullOrEmpty(evt.target)) {
      const layerName = evt.target.getAttribute('data-layer-name');
      if (!M.utils.isNullOrEmpty(layerName)) {
        evt.stopPropagation();
        let layer = this.map_.getLayers().filter(l => l.name === layerName)[0];
        if (M.utils.isNullOrEmpty(layer) && !M.utils.isNullOrEmpty(groupId)) {
          group = M.layer.LayerGroup.findGroupById(groupId, this.map_.getLayerGroup());
          layer = group.getChildren().find(l => ((l instanceof M.Layer) && (l.name === layerName)));
        }
        // checkbox
        if (evt.target.classList.contains('m-check')) {
          /* sets the layer visibility only if
             the layer is not base layer and visible */
          if (layer.transparent === true || !layer.isVisible()) {
            const opacity = evt.target.parentElement.parentElement.parentElement.parentElement.querySelector('div.tools > input');
            if (!M.utils.isNullOrEmpty(opacity)) {
              layer.setOpacity(opacity.value);
            }
            layer.setVisible(!layer.isVisible());
          }
        } else if (evt.target.classList.contains('m-completetoc-transparency')) {
          layer.setOpacity(evt.target.value);
        }
      }
    }
  }

  /**
   * Sets the visibility of the clicked layer
   *const groupId = evt.target.getAttribute('data-group-id');
   * @public
   * @function
   * @api stable
   */
  clickLayer(evtParameter) {
    const evt = (evtParameter || window.event);
    const groupId = evt.target.getAttribute('data-group-id');
    let group = null;
    let notRender = false;
    if (!M.utils.isNullOrEmpty(evt.target)) {
      const layerName = evt.target.getAttribute('data-layer-name');
      if (!M.utils.isNullOrEmpty(layerName)) {
        evt.stopPropagation();
        let layer = this.map_.getLayers().filter(l => l.name === layerName)[0];
        if (M.utils.isNullOrEmpty(layer) && !M.utils.isNullOrEmpty(groupId)) {
          group = M.layer.LayerGroup.findGroupById(groupId, this.map_.getLayerGroup());
          layer = group.getChildren().find(l => ((l instanceof M.Layer) && (l.name === layerName)));
        }
        // checkbox
        if (evt.target.classList.contains('m-check')) {
          if (layer.transparent === true || !layer.isVisible()) {
            const opacity = evt.target.parentElement.parentElement.parentElement.querySelector('div.tools > input');
            if (!M.utils.isNullOrEmpty(opacity)) {
              layer.setOpacity(opacity.value);
            }
            layer.setVisible(!layer.isVisible());
          }
        } else if (evt.target.classList.contains('m-completetoc-transparency')) {
          layer.setOpacity(evt.target.value);
        } else if (evt.target.classList.contains('m-completetoc-remove')) {
          this.map_.removeLayers(layer);
        } else if (evt.target.classList.contains('m-completetoc-zoom')) {
          if (layer.type === 'WMS') {
            layer.getImpl().getExtent().then((bbox) => {
              if (!M.utils.isNullOrEmpty(bbox)) {
                this.map_.setBbox(bbox);
              } else {
                M.dialog.info('No se puede obtener la extensión de la capa', 'Información');
              }
            });
          } else if (layer.type === 'WFS') {
            const extent = layer.getMaxExtent();
            this.map_.setBbox(extent);
          } else if (layer.type === 'KML') {
            const extent = layer.getImpl().getExtent();
            this.map_.setBbox(extent);
          } else if (layer.type === 'GeoJSON') {
            const extent = this.getImpl().getGeoJSONExtent(layer);
            this.map_.setBbox(extent);
          } else {
            M.dialog.info('No se puede obtener la extensión de la capa', 'Información');
          }
        } else if (evt.target.classList.contains('m-completetoc-metadata')) {
          const metadataUrl = layer.getImpl().options.metadataUrl;
          if (!M.utils.isNullOrEmpty(metadataUrl)) {
            M.remote.get(metadataUrl).then((response) => {
              if (!M.utils.isNullOrEmpty(response.text)) {
                const metadata = JSON.parse(response.text);
                metadata.language = this.getLanguage_(metadata.language);
                metadata.date_created_new = this.getDate_(metadata.date_created);
                metadata.date_resort_new = this.getDate_(metadata.date_resort);
                metadata.category = this.getCategory_(metadata.category);
                metadata.rpRole = this.getRole_(metadata.rpRole);
                metadata.theme = this.getTheme_(metadata.keyword);
                metadata.classification = this.getClassification_(metadata.keyword);
                const metadataText = M.template.compileSync(metadataTemplate, {
                  vars: metadata,
                  parseToHtml: false,
                  jsonp: true,
                });

                M.dialog.info(metadataText, 'Información');
                setTimeout(() => {
                  if (metadata.isPublic === true) {
                    document.querySelector('div.m-mapea-container div.m-dialog div.m-title')
                      .style.backgroundColor = '#5cb85c';
                    document.querySelector('div.m-mapea-container div.m-dialog div.m-button>button')
                      .style.backgroundColor = '#5cb85c';
                  } else if (metadata.isPublicInstance === true) {
                    document.querySelector('div.m-mapea-container div.m-dialog div.m-title')
                      .style.backgroundColor = '#fda823';
                    document.querySelector('div.m-mapea-container div.m-dialog div.m-button>button')
                      .style.backgroundColor = '#fda823';
                  } else {
                    document.querySelector('div.m-mapea-container div.m-dialog div.m-title')
                      .style.backgroundColor = '#d9534f';
                    document.querySelector('div.m-mapea-container div.m-dialog div.m-button>button')
                      .style.backgroundColor = '#d9534f';
                  }
                }, 10);
              } else {
                M.dialog.error('No se han podido obtener los metadatos de la capa', 'Error');
              }
            });
          }
        } else if (evt.target.classList.contains('m-completetoc-legend')) {
          const legend = evt.target.parentElement.parentElement.parentElement.querySelector('.m-legend');
          if (legend.style.display === 'block') {
            legend.style.display = 'none';
          } else {
            legend.style.display = 'block';
          }
          notRender = true;
        } else if (evt.target.classList.contains('m-completetoc-notcollapse')) {
          const parent = evt.target.parentElement;
          parent.style.display = 'none';
          parent.parentElement.querySelector('.m-legend-collapse').style.display = 'block';
          parent.parentElement.querySelector('.m-legend').style.display = 'block';
          notRender = true;
        } else if (evt.target.classList.contains('m-completetoc-collapse')) {
          const parent = evt.target.parentElement;
          parent.style.display = 'none';
          parent.parentElement.querySelector('.m-legend-notcollapse').style.display = 'block';
          parent.parentElement.querySelector('.m-legend').style.display = 'none';
          notRender = true;
        }
      } else if (!M.utils.isNullOrEmpty(groupId)) {
        const idGroup = evt.target.getAttribute('data-group-id');
        group = M.layer.LayerGroup.findGroupById(idGroup, this.map_.getLayerGroup());
        // checkbox
        if (evt.target.classList.contains('m-check')) {
          if (evt.target.classList.contains('icon-check-seleccionado')) {
            group.setVisible(false);
          } else {
            group.setVisible(true);
          }
          // collapse
        } else {
          group.collapsed = !group.collapsed;
          this.render();
        }
      }
    }

    if (!notRender) {
      this.render();
    }
  }

  /**
   * @function
   * @public
   * @api
   */
  getTemplateVariables(map) {
    return new Promise((success, fail) => {
      // gets base layers and overlay layers
      if (!M.utils.isNullOrEmpty(map)) {
        const baseLayers = map.getBaseLayers().filter(layer =>
          layer.displayInLayerSwitcher === true);
        const layerGroups = map.getLayerGroup();
        const orderedLayerGroups = this.orderLayerGroups_(layerGroups);
        const overlayLayers = map.getRootLayers().filter((layer) => {
          const isTransparent = (layer.transparent === true);
          const displayInLayerSwitcher = (layer.displayInLayerSwitcher === true);
          const isNotWMC = (layer.type !== M.layer.type.WMC);
          const isNotWMSFull = !((layer.type === M.layer.type.WMS) &&
          M.utils.isNullOrEmpty(layer.name));
          const hasNoGrp = layer.getLayerGroup && layer.getLayerGroup() === null;
          const isDraw = layer.type === 'Vector' && layer.name === 'selectLayer';
          return (isTransparent && isNotWMC && isNotWMSFull && displayInLayerSwitcher
            && hasNoGrp && !isDraw);
        }).reverse();

        const baseLayersPromise = Promise.all(baseLayers.map(this.parseLayerForTemplate_));
        const overlayLayersPromise = Promise.all(overlayLayers.map(this.parseLayerForTemplate_));
        const layerGroupsPromise = Promise.all(orderedLayerGroups
          .map(layerGroup => this.parseGroupForTemplate_(layerGroup, baseLayers))
          .filter(g => !M.utils.isNullOrEmpty(g)));
        baseLayersPromise.then((parsedBaseLayers) => {
          layerGroupsPromise.then((parsedLayerGroups) => {
            overlayLayersPromise.then(parsedOverlayLayers => success({
              baseLayers: parsedBaseLayers,
              overlayLayers: parsedOverlayLayers,
              layerGroups: parsedLayerGroups,
            }));
          });
        });
      }
    });
  }

  /**
   * @function
   * @public
   * @api
   */
  render() {
    this.getTemplateVariables(this.map_).then((templateVars) => {
      const html = M.template.compileSync(template, {
        vars: templateVars,
      });

      this.registerImgErrorEvents_(html);
      this.template_.innerHTML = html.innerHTML;
    });
  }

  registerImgErrorEvents_(html) {
    const imgElements = html.querySelectorAll('img');
    Array.prototype.forEach.call(imgElements, (imgElem) => {
      imgElem.addEventListener('error', (evt) => {
        const layerName = evt.target.getAttribute('data-layer-name');
        const legendErrorUrl = M.utils.concatUrlPaths([M.config.THEME_URL,
          M.layer.WMS.LEGEND_ERROR]);
        const layer = this.map_.getLayers().filter(l => l.name === layerName)[0];
        if (!M.utils.isNullOrEmpty(layer)) {
          layer.setLegendURL(legendErrorUrl);
        }
      });
    });
  }

  /**
   * This function is called on the control activation
   *
   * @public
   * @function
   * @api
   */
  activate() {
    super.activate();
  }
  /**
   * This function is called on the control deactivation
   *
   * @public
   * @function
   * @api
   */
  deactivate() {
    super.deactivate();
  }
  /**
   * This function gets activation button
   *
   * @public
   * @function
   * @param {HTML} html of control
   * @api
   */
  getActivationButton(html) {
    return html.querySelector('.m-completetoc button');
  }

  /**
   * This function compares controls
   *
   * @public
   * @function
   * @param {M.Control} control to compare
   * @api
   */
  equals(control) {
    return control instanceof CompleteTOCControl;
  }

  orderLayerGroups_(layerGroups) {
    return layerGroups.sort((a, b) => { // Descending order
      return b.order - a.order;
    });
  }

  /**
   *
   *
   * @private
   * @function
   */
  parseLayerForTemplate_(layer) {
    let layerTitle = layer.legend;
    if (M.utils.isNullOrEmpty(layerTitle)) {
      layerTitle = layer.name;
    }
    if (M.utils.isNullOrEmpty(layerTitle)) {
      layerTitle = 'Servicio WMS';
    }
    let isIcon = false;
    if (layer instanceof M.layer.Vector) {
      const style = layer.getStyle();
      if (style instanceof M.style.Point && !M.utils.isNullOrEmpty(style.get('icon.src'))) {
        isIcon = true;
      }
    }

    return new Promise((success, fail) => {
      const layerVarTemplate = {
        base: (layer.transparent === false),
        visible: (layer.isVisible() === true),
        id: layer.name,
        title: layerTitle,
        outOfRange: !layer.inRange(),
        opacity: layer.getOpacity(),
        metadata: !M.utils.isNullOrEmpty(layer.getImpl().options.metadataUrl),
        type: layer.type,
        isIcon,
      };
      const legendUrl = layer.getLegendURL();
      if (legendUrl instanceof Promise) {
        legendUrl.then((url) => {
          layerVarTemplate.legend = url;
          success(layerVarTemplate);
        });
      } else {
        layerVarTemplate.legend = layer.type !== 'KML' ? legendUrl : null;
        success(layerVarTemplate);
      }
    });
  }

  /**
   *
   *
   * @private
   * @function
   */
  parseGroupForTemplate_(groupLayer, baseLayers) {
    let layerTitle = groupLayer.title;
    if (M.utils.isNullOrEmpty(layerTitle)) {
      layerTitle = groupLayer.id;
    }
    if (M.utils.isNullOrEmpty(layerTitle)) {
      layerTitle = 'Conjunto de Servicios WMS';
    }
    let varTemplate = {
      id: groupLayer.id,
      title: layerTitle,
      order: groupLayer.order,
      collapsed: groupLayer.collapsed,
      layers: [],
      layerGroups: [],
    };

    groupLayer.getChildren().forEach((child) => {
      if (child instanceof M.Layer) {
        varTemplate.layers.push(this.parseLayerForTemplate_(child));
      } else if (child instanceof M.layer.LayerGroup) {
        const varGroup = this.parseLayerForTemplate_(child, baseLayers);
        if (!M.utils.isNullOrEmpty(varGroup)) {
          varTemplate.layerGroups.push(varGroup);
        }
      }
    });

    // Resolve the layers promise
    const promiseLayers = Promise.all(varTemplate.layers);
    promiseLayers.then((layers) => {
      if (!M.utils.isNullOrEmpty(varTemplate)) {
        varTemplate.layers = layers;
      }
    });

    let visibleLevel = 0;
    const layers = groupLayer.getAllLayers();
    if (layers.every(l => l.isVisible())) {
      visibleLevel = 2;
    } else if (layers.some(l => l.isVisible())) {
      visibleLevel = 1;
    }
    varTemplate.visible = visibleLevel;
    if (M.utils.isNullOrEmpty(varTemplate.layers) &&
    M.utils.isNullOrEmpty(varTemplate.layerGroups)) {
      varTemplate = null;
    }
    return varTemplate;
  }

  getCapabilitiesWFS_(url) {
    const layerUrl = url.replace('wfs?', 'wms?');
    const projection = this.map_.getProjection();
    const getCapabilitiesPromise = new Promise((success, fail) => {
      const wmsGetCapabilitiesUrl = M.utils.getWMSGetCapabilitiesUrl(layerUrl, '1.1.0');
      M.remote.get(wmsGetCapabilitiesUrl).then((response) => {
        const gcDoc = response.xml;
        const gcParser = new M.impl.format.WMSCapabilities();
        const gc = gcParser.read(gcDoc);
        const gcUtils = new M.impl.GetCapabilities(gc, layerUrl, projection);
        success(gcUtils);
      });
    });

    return getCapabilitiesPromise;
  }

  getClassification_(keywords) {
    const classifications = {
      infoCatalogueService: 'Catalogue service',
      humanCatalogueViewer: 'Catalogue viewer',
      humanChainDefinitionEditor: 'Chain definition editor',
      chainDefinitionService: 'Chain definition service',
      thematicChangeDetectionService: 'Change detection service',
      spatialCoordinateConversionService: 'Coordinate conversion service',
      spatialCoordinateTransformationService: 'Coordinate transformation service',
      infoCoverageAccessService: 'Coverage access service',
      spatialCoverageVectorConversionService: 'Coverage/vector conversion service',
      spatialDimensionMeasurementService: 'Dimension measurement service',
      comEncodingService: 'Encoding service',
      infoFeatureAccessService: 'Feature access service',
      humanFeatureGeneralizationEditor: 'Feature generalisation editor',
      spatialFeatureGeneralizationService: 'Feature generalisation service',
      thematicFeatureGeneralizationService: 'Feature generalisation service',
      spatialFeatureManipulationService: 'Feature manipulation services',
      spatialFeatureMatchingService: 'Feature matching service',
      infoFeatureTypeService: 'Feature type service',
      infoGazetteerService: 'Gazetteer service',
      thematicGeocodingService: 'Geocoding service',
      metadataGeographicAnnotationService: 'Geographic annotation services',
      comService: 'Geographic communication services',
      comGeographicCompressionService: 'Geographic compression service',
      humanGeographicDataStructureViewer: 'Geographic data-structure viewer',
      humanGeographicFeatureEditor: 'Geographic feature editor',
      comGeographicFormatConversionService: 'Geographic format conversion service',
      humanInteractionService: 'Geographic human interaction services',
      thematicGeographicInformationExtractionService: 'Geographic information extraction services',
      infoManagementService: 'Geographic model/information management service',
      metadataProcessingService: 'Geographic processing services – metadata',
      spatialProcessingService: 'Geographic processing services – spatial',
      temporalProcessingService: 'Geographic processing services – temporal',
      thematicProcessingService: 'Geographic processing services – thematic',
      humanGeographicSpreadsheetViewer: 'Geographic spreadsheet viewer',
      humanGeographicSymbolEditor: 'Geographic symbol editor',
      humanGeographicViewer: 'Geographic viewer',
      taskManagementService: 'Geographic workflow/task management services',
      thematicGoparameterCalculationService: 'Geoparameter calculation service',
      thematicGeoparsingService: 'Geoparsing service',
      spatialImageCoordinateConversionService: 'Image coordinate conversion service',
      spatialImageGeometryModelConversionService: 'Image geometry model conversion service',
      thematicImageManipulationService: 'Image Manipulation Services',
      thematicImageProcessingService: 'Image processing service',
      thematicImageSynthesisService: 'Image synthesis services',
      thematicImageUnderstandingService: 'Image understanding services',
      infoMapAccessService: 'Map access service',
      comMessagingService: 'Messaging service',
      thematicMultibandImageManipulationService: 'Multiband image manipulation',
      thematicObjectDetectionService: 'Object detection service',
      infoOrderHandlingService: 'Order handling service',
      spatialOrthorectificationService: 'Orthorectification service',
      spatialPositioningService: 'Positioning service',
      infoProductAccessService: 'Product access service',
      spatialProximityAnalysisService: 'Proximity analysis service',
      spatialRectificationService: 'Rectification service',
      thematicReducedResolutionGenerationService: 'Reduced resolution generation service',
      infoRegistryService: 'Registry Service',
      comRemoteFileAndExecutableManagement: 'Remote file and executable management',
      spatialRouteDeterminationService: 'Route determination service',
      spatialSamplingService: 'Sampling service',
      temporalSamplingService: 'Sampling service',
      infoSensorDescriptionService: 'Sensor description service',
      spatialSensorGeometryModelAdjustmentService: 'Sensor geometry model adjustment service',
      humanServiceEditor: 'Service editor',
      thematicSpatialCountingService: 'Spatial counting service',
      infoStandingOrderService: 'Standing order service',
      metadataStatisticalCalculationService: 'Statistical calculation service',
      subscriptionService: 'Subscription service',
      spatialSubsettingService: 'Subsetting service',
      temporalSubsettingService: 'Subsetting service',
      thematicSubsettingService: 'Subsetting service',
      temporalProximityAnalysisService: 'Temporal proximity analysis service',
      temporalReferenceSystemTransformationService: 'Temporal reference system transformation service',
      thematicClassificationService: 'Thematic classification service',
      spatialTilingChangeService: 'Tiling change service',
      comTransferService: 'Transfer service',
      humanWorkflowEnactmentManager: 'Workflow enactment manager',
      workflowEnactmentService: 'Workflow enactment service',
    };

    let classification = 'humanGeographicViewer';
    const filtered = keywords.filter((key) => {
      return classifications[key] !== undefined;
    });

    if (filtered.length > 0) {
      classification = classifications[filtered[0]];
    }

    return classification;
  }

  getDate_(time) {
    return new Date(time).toLocaleDateString();
  }

  getLanguage_(language) {
    const languages = {
      es: 'Español',
      en: 'Inglés',
      fr: 'Francés',
    };

    return languages[language];
  }

  getRole_(role) {
    const roles = {
      author: 'Autor',
      custodian: 'Conservador',
      originator: 'Creador',
      distributor: 'Distribuidor',
      publisher: 'Editor',
      principalInvestigator: 'Investigador principal',
      processor: 'Procesador',
      owner: 'Propietario',
      resourceProvider: 'Proveedor del recurso',
      pointOfContact: 'Punto de contacto',
      user: 'Usuario',
    };

    return roles[role];
  }

  getCategory_(category) {
    const categories = {
      farming: 'Agricultura',
      inlandWaters: 'Aguas interiores',
      climatologyMeteorologyAtmosphere: 'Atmósfera, climatología y meteorología',
      biota: 'Biota',
      imageryBaseMapsEarthCover: 'Cobertura de la Tierra con Mapas Básicos e Imágenes',
      economy: 'Economía',
      elevation: 'Elevación',
      structure: 'Estructuras',
      history: 'Historia',
      geoscientificInformation: 'Información Geocientífica',
      intelligenceMilitary: 'Inteligencia militar',
      justicePoliticsAdministration: 'Justicia, política, administración',
      boundaries: 'Límites',
      location: 'Localización',
      environment: 'Medio ambiente',
      oceans: 'Océanos',
      planningCadastre: 'Planeamiento Catastral',
      utilitiesCommunication: 'Redes de suministro',
      health: 'Salud',
      society: 'Sociedad',
      transportation: 'Transportes',
      tourism: 'Turismo',
    };

    return categories[category];
  }

  getTheme_(keywords = []) {
    const themes = [
      'Aspectos geográficos de carácter meteorológico',
      'Condiciones atmosféricas',
      'Cubierta terrestre',
      'Direcciones',
      'Distribución de la población — demografía',
      'Distribución de las especies',
      'Edificios',
      'Elevaciones',
      'Geología',
      'Hábitats y biotopos',
      'Hidrografía',
      'Instalaciones agrícolas y de acuicultura',
      'Instalaciones de observación del medio ambiente',
      'Instalaciones de producción e industriales',
      'Lugares protegidos',
      'Nombres geográficos',
      'Ortoimágenes',
      'Parcelas catastrales',
      'Rasgos geográficos oceanográficos',
      'Recursos energéticos',
      'Recursos minerales',
      'Redes de transporte',
      'Regiones biogeográficas',
      'Regiones marinas',
      'Salud y seguridad humanas',
      'Servicios de utilidad pública y estatales',
      'Sistema de cuadrículas geográficas',
      'Sistemas de coordenadas de referencia',
      'Suelo',
      'Unidades administrativas',
      'Unidades estadísticas',
      'Uso del suelo',
      'Zonas de riesgos naturales',
      'Zonas sujetas a ordenación, a restricciones o reglamentaciones y unidades de notificación',
      'Addresses',
      'Administrative units',
      'Agricultural and aquaculture facilities',
      'Area management/restriction/regulation zones and reporting units',
      'Atmospheric conditions',
      'Bio-geographical regions',
      'Buildings',
      'Cadastral parcels',
      'Coordinate reference systems',
      'Elevation',
      'Energy resources',
      'Environmental monitoring facilities',
      'Geographical grid systems',
      'Geographical names',
      'Geology',
      'Habitats and biotopes',
      'Human health and safety',
      'Hydrography',
      'Land cover',
      'Land use',
      'Meteorological geographical features',
      'Mineral resources',
      'Natural risk zones',
      'Oceanographic geographical features',
      'Orthoimagery',
      'Population distribution — demography',
      'Production and industrial facilities',
      'Protected sites',
      'Sea regions',
      'Soil',
      'Species distribution',
      'Statistical units',
      'Transport networks',
      'Utility and governmental services',
      'Adresses',
      'Altitude',
      'Bâtiments',
      'Caractéristiques géographiques météorologiques',
      'Caractéristiques géographiques océanographiques',
      'Conditions atmosphériques',
      'Dénominations géographiques',
      'Géologie',
      'Habitats et biotopes',
      'Hydrographie',
      'Installations agricoles et aquacoles',
      'Installations de suivi environnemental',
      'Lieux de production et sites industriels',
      'Occupation des terres',
      'Ortho-imagerie',
      'Parcelles cadastrales',
      'Référentiels de coordonnées',
      'Régions biogéographiques',
      'Régions maritimes',
      'Répartition de la population — démographie',
      'Répartition des espèces',
      'Réseaux de transport',
      'Ressources minérales',
      'Santé et sécurité des personnes',
      'Services d\'utilité publique et services publics',
      'Sites protégés',
      'Sols',
      'Sources d\'énergie',
      'Systèmes de maillage géographique',
      'Unités administratives',
      'Unités statistiques',
      'Usage des sols',
      'Zones à risque naturel',
      'Zones de gestion, de restriction ou de réglementation et unités de déclaration',
    ];

    let theme = themes[0];
    const filtered = keywords.filter((key) => {
      return themes.includes(key);
    });

    if (filtered.length > 0) {
      theme = filtered[0];
    }

    return theme;
  }
}
